
const getImagePool = (
  cruises,
  prevPool = { itineraryImages: [], displayedImages: [] },
) => {
  let imagePool = prevPool;
  cruises.map(cruise => {
    const images = cruise.masterSailing?.itinerary?.media?.images;
    if (
      !imagePool.itineraryImages.find(item => {
      return JSON.stringify(item) === JSON.stringify(images);
      }) &&
      images?.length
    ) {
      imagePool.itineraryImages.push(images);
    }
  });
  return imagePool;
};

export default getImagePool;
